import {
  MainCard,
  MainCardTitle,
  MainCardContent,
} from "src/components/main-card-type.tsx";
import { useIsVerified } from "src/components/email-verification";
import { Button } from "src/components/ui/button";
import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  sanitizeBrlValue,
  saveCalculatorData,
} from "src/utils/functions";
import { useEffect, useState } from "react";
import { ResponseHorasExtras } from "../horas-extras";

export const HorasInputCard = ({
  setResults,
}: {
  setResults: (value: ResponseHorasExtras | null) => void;
}) => {
  const calculatorKey = "horas-extras";
  const [message, setMessage] = useState<string>("");
  const isVerified = useIsVerified();

  const [valorBruto, setValorBruto] = useState("");
  const [jornada, setJornada] = useState("");
  const [horasNormais, setHorasNormais] = useState("");
  const [horasNoturnas, setHorasNoturnas] = useState("");
  const [horasCem, setHorasCem] = useState("");
  function clear() {
    setValorBruto("");
    setJornada("");
    setHorasNormais("");
    setHorasNoturnas("");
    setHorasCem("");
  }
  function handleSave() {
    saveCalculatorData(calculatorKey, {
      valorBruto,
      jornada,
      horasNormais,
      horasNoturnas,
      horasCem,
    });
  }
  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setValorBruto((savedData.valorBruto as string) || "");
    setJornada((savedData.jornada as string) || "");
    setHorasNormais((savedData.horasNormais as string) || "");
    setHorasNoturnas((savedData.horasNoturnas as string) || "");
    setHorasCem((savedData.horasCem as string) || "");
  }, []);
  function calculo() {
    if (!valorBruto) {
      setMessage("Por favor adicione um valor ao Salario Bruto.");
      setResults(null);
      return;
    }
    if (!jornada) {
      setMessage("Por favor adicione algum valor a Jornada");
      setResults(null);
      return;
    }
    if (!horasNormais) {
      setMessage("Por favor adicione um valor a horas Normais");
      setResults(null);
      return;
    }
    if (!horasNoturnas) {
      setMessage("Por favor adicione um valor a horas Noturnas");
      setResults(null);
      return;
    }
    if (!horasCem) {
      setMessage("Por favor adcione uma valor a horas 100%");
      setResults(null);
      return;
    }
    setMessage("");
    const SalarioBruto = Number.parseFloat(
      valorBruto.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );
    const ValorJornada = Number.parseFloat(
      jornada.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );
    const ValorHoraNormal = Number.parseFloat(
      horasNormais.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );
    const ValorHorasCem = Number.parseFloat(
      horasCem.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );
    const ValorHorasNortunas = Number.parseFloat(
      horasNoturnas.replace(/[^0-9,-]+/g, "").replace(",", "."),
    );

    let salarioBruto: number = SalarioBruto;
    let valorHora: number = 0;
    let horasExtrasNormais: number = 0;
    let horaNoturna: number = 0;
    let horaExtrasCem: number = 0;
    let valorFinal: number = 0;

    valorHora = SalarioBruto / ValorJornada;
    horasExtrasNormais = valorHora * 1.5 * ValorHoraNormal;
    horaNoturna = valorHora * 1.5 * 1.2 * ValorHorasNortunas;
    horaExtrasCem = valorHora * 2 * ValorHorasCem;

    console.log(horaExtrasCem, horaNoturna, horaExtrasCem);

    valorFinal = horasExtrasNormais + horaNoturna + horaExtrasCem;
    valorFinal = Math.round(valorFinal * 100) / 100;
    console.log(valorFinal, "Final");

    const response = {
      valorHora: valorHora,
      horasExtrasNormais: horasExtrasNormais,
      horaNoturna: horaNoturna,
      horaExtrasCem: horaExtrasCem,
      valorFinal: valorFinal,
      salarioBruto: salarioBruto,
    };

    setResults(response);
  }
  return (
    <MainCard>
      <MainCardTitle>Calculadora de Horas Extras</MainCardTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(calculo);
        }}
      >
        <MainCardContent>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="campo-id"
            >
              Salario Bruto *
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="campo-id"
                placeholder="00,00"
                type="text"
                value={valorBruto}
                onChange={(event) => setValorBruto(sanitizeBrlValue(event))}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="campo-id"
            >
              Jornada mensal (horas)
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="campo-id"
                placeholder="0"
                type="text"
                value={jornada}
                onChange={(event) => setJornada(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="campo-id"
            >
              Horas extras normais
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="campo-id"
                placeholder="0"
                type="text"
                value={horasNormais}
                onChange={(event) => setHorasNormais(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="campo-id"
            >
              Horas extras noturnas
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="campo-id"
                placeholder="0"
                type="text"
                value={horasNoturnas}
                onChange={(event) => setHorasNoturnas(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="campo-id"
            >
              Horas extras 100%
              <span className="pl-1 text-red-500">(domingo ou feriado)</span>
            </label>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="campo-id"
                placeholder="0"
                type="text"
                value={horasCem}
                onChange={(event) => setHorasCem(event.target.value)}
              />
            </div>
          </div>
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>
          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Button onClick={clear} variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>
      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};
